import React, { useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { createBrowserHistory } from 'history';

import styled from 'styled-components';
import ReactGA from 'react-ga4';

import Navigation from './Navigation';

import RoutesList from '../routes';

const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: stretch;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

const history = createBrowserHistory();
history.listen(location => {
  ReactGA.set({ page: location.pathname + location.search });
});

const App = ({ AppStore }) => {
  return (
    <Router history={history}>
      <ScrollToTop />
      <Navigation />
      <Body className='mainBody'>
        <RoutesList />
      </Body>
    </Router>
  )
}

export default inject("AppStore")(observer(App));
